import { FormHandler } from '@framework/form/form/FormHandler.tsx';
import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { t } from '@framework/i18n/intl/i18next.ts';
import { yup } from '@framework/validation/initYup.ts';

const searchSchema = yup.object({
  search: yup.string(),
});

interface IAdvancedSelectSearchInputProps {
  onChange: (value: string) => void;
}

/**
 * Campo di input per la ricerca all'interno della modale di selezione avanzata.
 */
export function AdvancedSelectSearchInput({
  onChange,
}: IAdvancedSelectSearchInputProps) {
  return (
    <FormHandler
      schema={searchSchema}
      initialValues={{ search: '' }}
      onSubmit={() => {}}
      hideVisualFeedback
      disableEnterSubmit
      disableReinitialize
      style={{ flex: 1 }}
    >
      <FormItem
        name="search"
        label={t('widgets.advanced-select.search-label', 'Cerca')}
        layout={{ hideVisualLabel: true, removeMargin: true }}
      >
        <TextInput
          name="search"
          placeholder={t(
            'widgets.advanced-select.search-placeholder',
            'Cerca...',
          )}
          allowClear
          onChange={value => onChange(value ?? '')}
        />
      </FormItem>
    </FormHandler>
  );
}
